import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { ActionButton } from '@/components/ActionButton';
import { LogDetailsCard } from '@/features/logs/LogCards';

export const Route = createFileRoute('/r/$restaurantId/logs/$eventId')({
  component: LogDetailsPage,
});

function LogDetailsPage() {
  const { restaurantId, eventId } = Route.useParams();

  return (
    <div className="space-y-4">
      <ActionButton asChild size="sm" variant="outline">
        <Link params={{ restaurantId }} to="/r/$restaurantId/logs">
          <ArrowLeft className="h-4 w-4" />
          Back to logs
        </Link>
      </ActionButton>
      <LogDetailsCard restaurantId={restaurantId} eventId={eventId} />
    </div>
  );
}
